import { UseFormReturn } from 'react-hook-form';
import { FormattedMessage, useIntl } from 'react-intl';

import InputFormField from 'src/registry/components/forms/InputFormField';
import { Form, FormControl, FormControlStack, FormField, FormItem, FormLabel, FormMessage } from 'src/registry/ui/Form';
import { commonMessages } from 'src/utils/messages';
import SelectFormField from 'src/registry/components/forms/SelectFormField';
import { BOOLEAN_MAP, BOOLEAN_OPTIONS } from 'src/features/moneyAccounts/utils/constants';
import { TaxReasonFormSchemaValues } from 'src/features/taxReasons/utils/formSchema';
import { taxReasonsMessages } from 'src/features/taxReasons/utils/messages';
import { Input } from 'src/registry/ui/Input';

type TaxReasonFormProps = {
    form: UseFormReturn<TaxReasonFormSchemaValues>;
    onSubmit: (values: TaxReasonFormSchemaValues) => void;
};

function TaxReasonForm({ onSubmit, form }: TaxReasonFormProps) {
    const { formatMessage } = useIntl();

    return (
        <Form form={form} onSubmit={form.handleSubmit(onSubmit)} variant="dialog">
            <InputFormField<TaxReasonFormSchemaValues>
                form={form}
                name="name"
                label={formatMessage(commonMessages.name)}
            />
            <FormField
                control={form.control}
                name="value"
                render={({ field }) => (
                    <FormItem variant="dialog">
                        <FormLabel variant="dialog" required>
                            <FormattedMessage {...taxReasonsMessages.value} />
                        </FormLabel>
                        <FormControlStack>
                            <FormControl>
                                <Input
                                    type="text"
                                    inputMode="decimal"
                                    placeholder={`${formatMessage(taxReasonsMessages.value)}...`}
                                    value={field.value ?? ''}
                                    onChange={(e) => {
                                        const inputValue = e.target.value;
                                        if (inputValue === '' || /^\d{0,20}(?:\.\d{0,4})?$/.test(inputValue)) {
                                            field.onChange(inputValue);
                                        }
                                    }}
                                />
                            </FormControl>
                            <FormMessage />
                        </FormControlStack>
                    </FormItem>
                )}
            />
            <SelectFormField<TaxReasonFormSchemaValues>
                form={form}
                name="is_default"
                isBoolean={true}
                label={formatMessage(taxReasonsMessages.isDefault)}
                options={Object.values(BOOLEAN_OPTIONS)}
                optionTranslationMap={BOOLEAN_MAP}
            />
            <SelectFormField<TaxReasonFormSchemaValues>
                form={form}
                name="is_active"
                isBoolean={true}
                label={formatMessage(taxReasonsMessages.isActive)}
                options={Object.values(BOOLEAN_OPTIONS)}
                optionTranslationMap={BOOLEAN_MAP}
            />
        </Form>
    );
}

export default TaxReasonForm;
